

export const frontMatter = {};
export const contentTitle = 'BASEMAP';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-api-reference-carto-basemap-md-09b.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Usage",
  "id": "usage",
  "level": 2
}, {
  "value": "React",
  "id": "react",
  "level": 3
}, {
  "value": "Standalone",
  "id": "standalone",
  "level": 3
}, {
  "value": "Supported basemaps",
  "id": "supported-basemaps",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "basemap",
        children: "BASEMAP"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://carto.com/basemaps/",
        children: "CARTO basemaps"
      }), " are available and they can be used without a token."]
    }), "\n", _jsxs(_components.p, {
      children: ["Ensure you follow the ", _jsx(_components.a, {
        href: "https://drive.google.com/file/d/1P7bhSE-N9iegI398QYDjKeVhnbS7-Ilk/view",
        children: "Terms and Conditions"
      }), " when using them."]
    }), "\n", _jsx(_components.h2, {
      id: "usage",
      children: "Usage"
    }), "\n", _jsx(_components.h3, {
      id: "react",
      children: "React"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Important Note:"
      }), " Mapbox-GL-JS v2.0 changed to a license that requires an API key for loading the library, which will prevent you from using ", _jsx(_components.code, {
        children: "react-map-gl"
      }), " ( a higher level library). They have an in-depth guide about it ", _jsx(_components.a, {
        href: "https://github.com/visgl/react-map-gl/blob/v6.0.0/docs/get-started/mapbox-tokens.md",
        children: "here"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["In short, if you want to use the library without a Mapbox token, then you have two options: use a ", _jsx(_components.code, {
        children: "react-map-gl"
      }), " version less than 6.0 (", _jsx(_components.code, {
        children: "npm i react-map-gl@5"
      }), "), or ", _jsxs(_components.a, {
        href: "https://github.com/visgl/react-map-gl/blob/v6.0.0/docs/get-started/get-started.md#using-with-a-mapbox-gl-fork",
        children: ["substitute ", _jsx(_components.code, {
          children: "mapbox-gl"
        }), " with a fork"]
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "To install the dependencies from NPM:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-bash",
        children: "npm install deck.gl\n# or\nnpm install @deck.gl/core @deck.gl/layers @deck.gl/carto\n"
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "import {DeckGL} from '@deck.gl/react';\nimport {Map} from 'react-map-gl/maplibre';\nimport {BASEMAP} from '@deck.gl/carto';\n<DeckGL initialViewState={INITIAL_VIEW_STATE} controller={true} layers={layers}>\n  <StaticMap mapStyle={BASEMAP.POSITRON} />\n</DeckGL>;\n"
      })
    }), "\n", _jsx(_components.h3, {
      id: "standalone",
      children: "Standalone"
    }), "\n", _jsx(_components.p, {
      children: "To use pre-bundled scripts:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-html",
        children: "<script src=\"https://unpkg.com/deck.gl@^9.0.0/dist.min.js\"></script>\n<script src=\"https://unpkg.com/@deck.gl/carto@^9.0.0/dist.min.js\"></script>\n\n<!-- or -->\n<script src=\"https://unpkg.com/@deck.gl/core/@^9.0.0/dist.min.js\"></script>\n<script src=\"https://unpkg.com/@deck.gl/layers@^9.0.0/dist.min.js\"></script>\n<script src=\"https://unpkg.com/@deck.gl/mesh-layers@^9.0.0/dist.min.js\"></script>\n<script src=\"https://unpkg.com/@deck.gl/geo-layers@^9.0.0/dist.min.js\"></script>\n<script src=\"https://unpkg.com/@deck.gl/extensions@^9.0.0/dist.min.js\"></script>\n<script src=\"https://unpkg.com/@deck.gl/carto@^9.0.0/dist.min.js\"></script>\n\n<!-- basemap provider -->\n<script src=\"https://unpkg.com/maplibre-gl/dist/maplibre-gl.js\"></script>\n"
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "const map = new maplibregl.Map({\n  container: 'map',\n  style: deck.carto.BASEMAP.POSITRON,\n  interactive: false\n})\nconst deckgl = new deck.DeckGL({\n  canvas: 'deck-canvas',\n  initialViewState: {\n    latitude: 0,\n    longitude: 0,\n    zoom: 1\n  },\n  onViewStateChange: ({viewState}) => {\n    const {longitude, latitude, ...rest} = viewState;\n    map.jumpTo({center: [longitude, latitude], ...rest});\n  }\n  controller: true\n});\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "supported-basemaps",
      children: "Supported basemaps"
    }), "\n", _jsx(_components.p, {
      children: "There are several basemaps available today:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "POSITRON"
      }), "\n", _jsx(_components.li, {
        children: "DARK_MATTER"
      }), "\n", _jsx(_components.li, {
        children: "VOYAGER"
      }), "\n", _jsx(_components.li, {
        children: "POSITRON_NOLABELS"
      }), "\n", _jsx(_components.li, {
        children: "DARK_MATTER_NOLABELS"
      }), "\n", _jsx(_components.li, {
        children: "VOYAGER_NOLABELS"
      }), "\n"]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "NAME"
          }), _jsx(_components.th, {
            children: "PREVIEW"
          }), _jsx(_components.th, {
            children: "STYLE URL"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "POSITRON"
          }), _jsx(_components.td, {
            children: _jsx("img", {
              src: "https://carto.com/help/images/building-maps/basemaps/positron_labels.png"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
              children: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "DARK_MATTER"
          }), _jsx(_components.td, {
            children: _jsx("img", {
              src: "https://carto.com/help/images/building-maps/basemaps/dark_labels.png"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json",
              children: "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "VOYAGER"
          }), _jsx(_components.td, {
            children: _jsx("img", {
              src: "https://carto.com/help/images/building-maps/basemaps/voyager_labels.png"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json",
              children: "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "POSITRON_NOLABELS"
          }), _jsx(_components.td, {
            children: _jsx("img", {
              src: "https://carto.com/help/images/building-maps/basemaps/positron_no_labels.png"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://basemaps.cartocdn.com/gl/positron-nolabels-gl-style/style.json",
              children: "https://basemaps.cartocdn.com/gl/positron-nolabels-gl-style/style.json"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "DARK_MATTER_NOLABELS"
          }), _jsx(_components.td, {
            children: _jsx("img", {
              src: "https://carto.com/help/images/building-maps/basemaps/dark_no_labels.png"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json",
              children: "https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "VOYAGER_NOLABELS"
          }), _jsx(_components.td, {
            children: _jsx("img", {
              src: "https://carto.com/help/images/building-maps/basemaps/voyager_no_labels.png"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://basemaps.cartocdn.com/gl/voyager-nolabels-gl-style/style.json",
              children: "https://basemaps.cartocdn.com/gl/voyager-nolabels-gl-style/style.json"
            })
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

